import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'
import numeral from 'numeral'

class JobsAdded extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/payment-requests/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Job ID',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace('/', '-')}`
            return (
              <a href={jobUrl} target="_blank">
                {item.job_id}
              </a>
            )
          }
        }
      },
      {
        title: 'Job Name',
        dataIndex: 'job_name'
      },
      {
        title: 'Type',
        dataIndex: 'type'
      },
      {
        title: 'Amount',
        dataIndex: 'amount_formatted'
      },
      {
        title: 'Payable To',
        dataIndex: 'payable_to_object',
        render: item => {
          if (item && item.name) {
            let vendorUrl = `/vendors/${item.id}`
            return (
              <a href={vendorUrl} target="_blank">
                {item.name}
              </a>
            )
          }
        }
      },
      {
        title: 'Payable From',
        dataIndex: 'payable_from'
      },
      {
        title: 'Check Number',
        dataIndex: 'check_number'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Due Date',
        dataIndex: 'due_date',
        sorter: (a, b) => {
          if (moment(a.due_date).isBefore(moment(b.due_date))) {
            return -1
          }
          return 1
        }
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    let data = fullReport.map((item, index) => {
      item.due_date = moment(new Date(item.due_date)).format('YYYY-M-D')
      item.amount_formatted = numeral(item.amount).format('$0,0.00')
      item.job = {
        job_id: item.job_id,
        job_type: item.job_type,
        id: item.id
      }
      item.payable_to_object = {
        name: item.payable_to_company_name,
        id: item.payable_to_company_id
      }
      return item
    })

    return data
  }

  getTotalAmount = () => {
    const { fullReport } = this.props
    var sum = 0
    fullReport.forEach(item => {
      sum += item.amount
    })
    return sum
  }

  tableComponents = (key = 'tableKey') => ({ className, style, children }) => (
    <table className={className} style={style} key={key}>
      {children}
      <tfoot>
        <tr>
          <td className="padding8">Totals</td>
          <td />
          <td />
          <td />
          <td className="padding8">{numeral(this.getTotalAmount()).format('$0,0.00')}</td>
          <td />
          <td />
          <td />
          <td />
        </tr>
      </tfoot>
    </table>
  )

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              components={{ table: this.tableComponents() }}
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default JobsAdded



// WEBPACK FOOTER //
// ./src/components/reports/financial/payment-request-report/ListItems.js